import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const defaultProps = {
  className: ''
};

export default class RightRail extends Component {
  render() {
    const classes = [this.props.className, 'rec-grid-4-12'].filter((v) => v !== "").join(' ');

    return (
      <aside className={classes}>
        {this.props.children}
      </aside>
    );
  }
}

RightRail.propTypes = propTypes;
RightRail.defaultProps = defaultProps;
